import { Box, Typography, Button } from "@mui/material";
import { useAuth } from "../hooks";
import { useNavigate } from "react-router-dom";

type GroupInvitationNotificationProps = {
  username: string | undefined;
  time: string | undefined;
  type: "groupCallInvitation";
  onConfirm: () => void;
  onReject: () => void;
  price?: string; // optional because it's only required for the payment variant
  invited_by?: string;
  payment_status?: string;
  closePopover: () => void;
  cardName?: number | string;
  suit?: string;
  talent_username?: string;
};

const GroupInvitationNotification: React.FC<
  GroupInvitationNotificationProps
> = ({
  username,
  time,
  type,
  onConfirm,
  onReject,
  price,
  invited_by,
  payment_status,
  closePopover,
  cardName,
  suit,
  talent_username,
}) => {
  const { userInfo } = useAuth();
  const purchasedChips = userInfo?.wallet_purchase?.available_chips || 0;
  const earnedChips = userInfo?.wallet_earning?.available_chips || 0;

  // const [openPaymentModal, setOpenPaymentModal] = useState(false);
  // const handleOpen = () => setOpenPaymentModal(true);
  // const handleClose = () => setOpenPaymentModal(false);
  // const handleConfirm = () => {
  //   setOpenPaymentModal(false);
  //   onConfirm();
  // };

  const navigate = useNavigate();

  const isPayment = payment_status === "Unpaid";

  const handleButtonClick = () => {
    navigate("/notification");
    closePopover();
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-start",
          gap: "20px",
          textAlign: "center",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            textAlign: "left",
          }}
        >
          <Typography sx={{ font: "var(--semibold-xs)" }}>
            Group session invitation
          </Typography>
          <Typography sx={{ font: "var(--body-xxs)", lineHeight: "12px" }}>
            You have been invited to a group session. Please confirm to book
            your seat.
          </Typography>
          {username && (
            <Typography
              sx={{ font: "var(--semibold-xxs)", color: "var(--primary-800)" }}
            >
              Talent: <Box component="span">{talent_username}</Box>
            </Typography>
          )}
          {cardName && (
            <Typography
              sx={{ font: "var(--semibold-xxs)", color: "var(--primary-800)" }}
            >
              Card name: <Box component="span">{cardName}</Box>
            </Typography>
          )}
          {invited_by && (
            <Typography
              sx={{ font: "var(--semibold-xxs)", color: "var(--primary-800)" }}
            >
              Invited by: <Box component="span">{invited_by}</Box>
            </Typography>
          )}
          {time && (
            <Typography
              sx={{ font: "var(--semibold-xxs)", color: "var(--primary-800)" }}
            >
              Date: <Box component="span">{time}</Box>
            </Typography>
          )}
          {time && (
            <Typography
              sx={{ font: "var(--semibold-xxs)", color: "var(--primary-800)" }}
            >
              Time: <Box component="span">{time}</Box>
            </Typography>
          )}
          {payment_status && (
            <Typography
              sx={{ font: "var(--semibold-xxs)", color: "var(--primary-800)" }}
            >
              Payment Status: <Box component="span">{payment_status}</Box>
            </Typography>
          )}
          {isPayment && (
            <>
              <Typography
                sx={{
                  font: "var(--semibold-xxs)",
                  color: "var(--primary-800)",
                }}
              >
                Required Chips: <Box component="span">{price}</Box>
              </Typography>
              <Typography
                sx={{
                  font: "var(--semibold-xxs)",
                  color: "var(--primary-800)",
                }}
              >
                Your current Chips:{" "}
                <Box component="span">{purchasedChips + earnedChips}</Box>
              </Typography>
            </>
          )}
        </Box>

        <Box
          //   width="100%"
          sx={{
            // minWidth: "110px",
            gap: "10px",
            display: "flex",
            alignItems: "flex-start",
            flexDirection: "column",
            justifyContent: "flex-start",
          }}
        >
          <Button
            // onClick={isPayment ? handleOpen : onConfirm}
            onClick={handleButtonClick}
            variant="contained"
            sx={{
              // width: "100%",
              background: "var(--button-gradient)",
              color: "var(--neutralWhite)",
              textTransform: "none",
              font: "var(--semibold-xxs)",
              padding: "var(--spacing-4x)",
              boxShadow: "none",
              borderRadius: "8px !important",
              "&:hover": {
                background: "var(--button-gradient-hover)",
              },
            }}
          >
            {/* {isPayment ? "Accept and Pay" : "Accept"} */}
            View
          </Button>

          {/* <Button
            onClick={onReject}
            variant="contained"
            sx={{
              width: "100%",
              background: "var(--destructive-600)",
              textTransform: "none",
              lineHeight: "20px",
              font: "var(--semibold-xxs)",
              padding: "var(--spacing-4x)",
              boxShadow: "none",
              borderRadius: "8px !important",
              color: "var(--neutralWhite)",
              "&:disabled": {
                background: "var(--destructive-300)",
              },
            }}
          >
            Reject
          </Button> */}
        </Box>
      </Box>

      {/* Payment Modal */}
      {/* {isPayment && (
        <Dialog
          open={openPaymentModal}
          onClose={handleClose}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle>Confirm Payment</DialogTitle>
          <DialogContent dividers>
            <Typography>
              You are about to pay <strong>{price} chips</strong>. Do you want
              to continue?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              sx={{
                border: " 1px solid var(--neutral-300)",
                textTransform: "none",
                font: "var(--semibold-xxs)",
                padding: "var(--spacing-4x)",
                boxShadow: "none",
                borderRadius: "8px !important",
                color: "var(--neutral-500)",
              }}
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              sx={{
                background: "var(--button-gradient)",
                color: "var(--neutralWhite)",
                textTransform: "none",
                font: "var(--semibold-xxs)",
                padding: "var(--spacing-4x)",
                boxShadow: "none",
                borderRadius: "8px !important",
                "&:hover": {
                  background: "var(--button-gradient-hover)",
                },
              }}
              onClick={handleConfirm}
              variant="contained"
            >
              Confirm and Pay
            </Button>
          </DialogActions>
        </Dialog>
      )} */}
    </>
  );
};

export default GroupInvitationNotification;
